export default __webpack_public_path__ + "static/media/img_5.9e3d9306.svg";